export const VARIANT_DEFAULT_VALUE = 'major';
export const COLOR_DEFAULT_VALUE = 'interactive-kg-blue';
export const IS_FONT_AWESOME = 'font-awesome';
export const IS_SVG = 'svg';
export const BUTTON_TYPE = 'button';
